/**
 * PD-6665: Cross out the booking fee and show the remaining fee after welcome credit.
 *
 * Eligibility lives in GrowthBook. Credit amount is read at the banner for the math.
 *
 * @see https://firsttable.atlassian.net/browse/PD-6665
 * @see https://app.growthbook.io/features/pd-6665-new-user-discount
 * @see https://app.growthbook.io/experiment/exp_19g6mmtauk7df
 */
export const PD6665_NEW_USER_DISCOUNT_FLAG = 'pd-6665-new-user-discount';
